<template>
  <div class="indicator-point"></div>
</template>

<style scoped lang="scss">
  @import './styles';
</style>
